import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import {
  SnackbarContainer,
  SnackbarLeft,
  SnackbarMiddle,
  SnackbarMessage,
  SnackbarButtonAction,
  SnackbarRight
} from '../styled-components'

import {
  snackbarVariantOptions,
  snackbarStyleVariantOptions
} from '../constants'
import { Cancel } from '../../../atoms/icons/essentials'

const SnackbarItem = ({
  message,
  snackbarType = snackbarVariantOptions.STANDART,
  buttonAction,
  isOpen = true,
  persistOpen = false,
  timeToHide = 3000,
  hideCloseButton = true,
  onClose = () => {},
  ...props
}) => {
  const [showSnackbar, setShowSnackbar] = useState(isOpen)
  const [animation, setAnimation] = useState('showIn')

  const closeSnakbar = () => {
    setAnimation('showOut')
    debounce(() => {
      setShowSnackbar(false)
      onClose()
    }, 500)()
  }

  useEffect(() => {
    if (!persistOpen) {
      const timeoutId = setTimeout(() => {
        closeSnakbar()
      }, timeToHide)

      return () => clearTimeout(timeoutId)
    }
  }, [])

  if (!showSnackbar) {
    return
  }

  return (
    <SnackbarContainer
      snackbarType={snackbarType}
      animation={animation}
      {...props}
    >
      <SnackbarLeft>
        {snackbarStyleVariantOptions[snackbarType]?.icon}
      </SnackbarLeft>

      <SnackbarMiddle
        snackbarType={snackbarType}
        hideCloseButton={hideCloseButton}
      >
        <SnackbarMessage snackbarType={snackbarType}>{message}</SnackbarMessage>
        {buttonAction && (
          <SnackbarButtonAction>{buttonAction}</SnackbarButtonAction>
        )}
      </SnackbarMiddle>
      {!hideCloseButton && (
        <SnackbarRight>
          <Cancel
            size="icon-s"
            stroke={snackbarStyleVariantOptions[snackbarType]?.colorCloseIcon}
            onClick={closeSnakbar}
          />
        </SnackbarRight>
      )}
    </SnackbarContainer>
  )
}

SnackbarItem.propTypes = {
  message: PropTypes.string,
  snackbarType: PropTypes.oneOf(Object.values(snackbarVariantOptions)),
  buttonAction: PropTypes.node,
  isOpen: PropTypes.bool,
  persistOpen: PropTypes.bool,
  timeToHide: PropTypes.number,
  onClose: PropTypes.func
}

export default SnackbarItem
